/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancel',
    CLOSE: 'Close',
    CONFIRM: 'Confirm',
    CONFIRM_AND_NEXT: 'Confirm and next',
    CONFIRM_AND_SAVE: 'Confirm and save',
    CREATE: 'Create',
    DELETE: 'Delete',
    EDIT: 'Edit',
    NEW_POST: 'New post',
    OK: 'Ok',
    REJECTED: 'Rejected',
    REPLY: 'Reply',
    SAVE: 'Save',
    SEND: 'Send',
    SKIP_CROP: 'Skip crop',
    UPDATE: 'Update',
    UPGRADE: 'Join club'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'Fail copying to clipboard!',
    INSTAGRAM_PUBLISHING_ERROR:
      'An error occurred while sharing the post on Instagram.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'An error occurred while sharing the post on Instagram. Would you like to proceed with the publication?',
    LINK_ALREADY_EXISTS: 'Link already exists',
    LINK_VALIDATION_FAILED: 'Unable to validate the link',
    MANDATORY_FIELD: 'Mandatory field',
    MAXIMUM_CHARACTERS: 'Maximum characters reached',
    MAXIMUM_FILE_SIZE: 'The maximum size allowed is 100MB!',
    MINIMUM_DIMENSIONS:
      'The uploaded file must have minimum dimensions of 480×960',
    PAGE_NOT_APPROVED:
      '❌ Unfortunately, your page could not be approved this time. But don’t worry! ✨\n You can edit your profile and correct the indicated fields to resubmit it for approval.',
    REACTION_LIKE: 'There was an error please try again later!',
    UNSUPPORTED_FORMAT: 'Unsupported format!',
    VIDEO_CROP: 'Video crop fail!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'I accept the terms and conditions',
    ADDITIONAL_INFORMATION: 'Additional information',
    ADDRESS: 'Address',
    APPROVED: 'published',
    ASSETS: 'Images or videos (maximum size 100MB)',
    ASSOCIATE_PRODUCT: 'Associate prozis product',
    ASSOCIATED_PRODUCTS: 'Associated prozis products',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Caption',
    CHART_BY: 'Chart by',
    COMMENTS: 'Comments',
    COMMISSION: 'commission',
    COMMISSIONS: 'commissions',
    COMMISSIONS_LAST_30_DAYS: 'last 30 days',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Full address without house number',
    CONTINUE_WITH_INSTAGRAM: 'Continue with Instagram',
    COUNTRY: 'Address with country only',
    CREATE_PROFILE: 'Create your profile',
    CROPPING_ASSET: 'Crop {asset} {ratio}',
    DELETE_POST: 'Delete post?',
    DELETE_POST_ARE_YOU_SURE: 'Are you sure you want to delete the post?',
    DESCRIPTION: 'Bio',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Download',
    DRAFT_PROFILE: 'Draft',
    EDIT_PROFILE: 'Edit page',
    ENGAGEMENT: 'Engagement',
    ERROR: 'Error',
    FEED: 'feed',
    FOLLOWERS: 'Followers',
    FRIDAY: 'Friday',
    GALLERY: 'Gallery',
    HIDDEN: 'Does not show address',
    IMAGE: 'image',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Instagram account',
    LATEST_FIRST: 'Latest first',
    LEAST_PROFITABLE: 'Least profitable first',
    LIKES: 'Likes',
    LIKES_DELETED: 'Likes removed',
    LINK: 'Link',
    LIVE: 'Live',
    LIVES: 'Live',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Address with city and country only',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Full address',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Full address without door number',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Address with country only',
    MONDAY: 'Monday',
    MORE: '... See more',
    MOST_PROFITABLE: 'Most profitable first',
    NAME: 'Name',
    NEW_FOLLOWERS: 'New followers',
    NEW_POST: 'New post',
    NO_PRODUCTS_FOUND: 'No products found.',
    NUMBER_OF_FILES: '{file} of {files}',
    OLDEST_FIRST: 'Oldest first',
    ORIGINAL: 'Original',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Page photos',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} d',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'pending',
    POST: 'Post',
    POST_COMMENTS: 'Post comments',
    POST_PRODUCTS: 'Post products',
    POST_VIEWS: 'Post views',
    POSTING_ON_INSTAGRAM: 'Posting on Instagram',
    POSTS: 'Posts',
    PRODUCTS_HASHTAGS: 'Products hashtags',
    PRODUCTS_LINKS: 'Products links',
    PROFESSIONAL_PAGE: 'Professional Page',
    PROFILE: 'Profile',
    PROFILE_PHOTO: 'Profile photo',
    PROFILE_STATUS: 'Profile state',
    PROFILE_VIEWS: 'Profile views',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Prozis Community',
    QUESTION: 'Question',
    QUESTION_REPLY: 'Question reply',
    QUESTIONS: 'Questions',
    REELS: 'reels',
    REJECTED: 'not published',
    REJECTED_PROFILE: 'Rejected',
    REJECTION_REASON: 'Rejection reason',
    REPLY: 'Reply',
    REQUIRED_FIELDS: 'Required fields',
    RESET: 'Clear',
    SATURDAY: 'Saturday',
    SEARCH: 'Search',
    SEARCH_AT_LEAST: 'The search word must be at least 3 characters!',
    SEE_LESS: 'Hide',
    SEE_MORE: 'See more',
    SEE_ORIGINAL: 'See original',
    SEE_TRANSLATION: 'See translation',
    SHARE_ON_INSTAGRAM: 'Share on Instagram',
    SHARE_PROFILE: 'Share page',
    SOCIAL_NETWORK: 'Social network',
    SOCIAL_NETWORK_COMMISSIONS: 'Social network commissions',
    SOCIAL_NETWORK_PAGE: 'Social Page',
    SOUND: 'Sound',
    SPECIALTIES: 'Specialties',
    STATISTICS_POST: 'Post statistics',
    STATISTICS_PROFILE: 'Profile statistics',
    STATS_POST_TOTAL: 'Total post commissions',
    STATS_POST_TOTAL_COMMENTS: 'Post comments/questions',
    STATS_POST_TOTAL_LIKES: 'Post obtained likes',
    STATS_POST_TOTAL_PRODUCTS: 'Post associated products',
    STATS_POST_TOTAL_QUESTIONS: 'Post questions answered',
    STATS_POST_TOTAL_VALUE: 'Post value',
    STATS_PROFILE_TOTAL: 'Total posts commissions',
    STATS_PROFILE_TOTAL_COMMENTS: 'Posts comments/questions',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'New followers gained',
    STATS_PROFILE_TOTAL_LIKES: 'Posts likes',
    STATS_PROFILE_TOTAL_POSTS: 'Posts obtained value',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Posts associated products',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Posts questions answered',
    STORY: 'story',
    SUCCESS: 'Success',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Terms and conditions',
    THURSDAY: 'Thursday',
    TITLE: 'Title',
    TOTAL_VIEWS: 'Total views',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Unfollowers',
    UNREAD: 'Unread',
    UPDATE_POST: 'Update post',
    UPDATED: 'Updated {date}',
    UPLOAD: 'Upload file',
    UPLOADING_FILES: 'Uploading file(s)',
    USER_NAME: 'User name',
    VIDEO: 'Video',
    VIEW_ALL_COMMENTS: 'View all {total} comments',
    VIEW_MORE: 'View more',
    VIEWS: 'Views',
    VISIBILITY_LEVEL: 'Visibility level',
    WAITING_APPROVAL: 'Waiting for approval',
    WARNING: 'Warning',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Your profile'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'No questions yet.',
    TERMS_AND_CONDITIONS:
      'By interacting with the Prozis “Social Network” (by way of example and not exhaustively, making comments and/or sharing content and reactions directly), the User declares to have read, understood and accepted the following Terms and Conditions (T & C) .\n\nProzis reserves the right to update the Terms and Conditions at any time without prior notice. Prozis shall be entitled to operate all legal and fair remedies available to it.\n\nBy accessing the “Social Network”, the User declares to be at least 18 years of age and assumes all responsibility for publications, comments, images and videos sent (“Content”) on the “Social Network”.\n\nThe Content must belong to the User, who declares to be the author and holder of any and all intellectual property. The Content must not represent any particular situation, building or object and/or protected by copyright, trademark or, in general, trademarks and logos of other companies, unless the User has obtained the necessary consent for its use.\n\nThe Content must not include any person other than the User, unless consent is given by the same person in writing and which the User is responsible for obtaining. The User will indemnify and hold Prozis harmless in case of damage caused by the use of such images and/or videos.\n\nOnce shared, the Content will be the exclusive property of Prozis, which will be authorized to publish and/or disseminate and/or use and/or reproduce and/or communicate and/or modify, by any technical means and in any way, the Content aforementioned, without exclusion, without deadlines and without right to any compensation and/or compensation for the subjects involved and/or interested.\n\nAfter the possible upload of a content, Prozis reserves the right to make visible only the material that, in its own unquestionable judgment, is not harmful to the image of others, as well as offensive to current morals, or otherwise harmful to the rights of others; biased, defamatory, obscene, vulgar, slanderous, racist, or that constitutes a form of publicity for any commercial activity not inherent to the proposed theme or in any case that aims to promote any brand, product, service other than that of the "Social Network", with Non-original User content, that is, copied from other sources, with content in violation of the Portuguese legal system, contrary to public decency, privacy regulations and, in general, current legislation.\n\nProzis also reserves the right to delete, before or after publication, any comment that, in its sole discretion, may be offensive, inappropriate and/or inconsistent with the spirit of the “Social Network”.\n\nProzis also reserves the right, at any time, to remove comments and/or content published on its "Social Network", independently or at the request of third parties, as well as Judicial Authorities, in case of disputes regarding the legality or legitimacy of said post or comment. Only if the Content is deemed adequate by the moderation of the “Social Network” will it be made visible.\n\nAfter uploading Content to the "Social Network", Prozis reserves the right to directly re-upload or share the User Content on its digital platforms to promote its brand.',
    WITHOUT_POSTS: 'No posts yet.',
    WITHOUT_POSTS_STATISTICS: 'Without posts between the chosen dates.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Link successfully copied to clipboard!',
    CREATED_SUCCESSFULLY: 'Created successfully!',
    ERROR_PUBLISHING_INSAGRAM: 'The post was published on Instagram.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'The post was successfully published on Instagram.',
    POST_CREATED_SUCCESSFULLY: 'Created successfully!',
    POST_SAVED_SUCCESSFULLY: 'Saved successfully!',
    POST_SUCCESSFULLY_DELETED: 'Successfully deleted.',
    SAVED_SUCCESSFULLY: 'Saved successfully!',
    SUCCESSFULLY_DELETED: 'Successfully deleted.',
    SUCCESSFULLY_REPLIED: 'Successfully replied.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS: 'Please accept the terms and conditions!',
    EMPTY_PROFILE_IMAGE: 'Must upload a profile picture!',
    INVALID_FORM: 'Invalid form!'
  }
};
